<template>
    <div>

        <el-container>



            <div style="position: relative;width: auto;height: auto ; left:10px;top:0px"   >
                <table style="position: relative; width: auto;height: auto; margin: 0 auto; float: left"  >
                    <tr>
                        <td >
                            <el-button style="margin-left: 10px" size="small" type="primary"  plain @click="showQuery" >查询条件
                            </el-button>
                        </td>
                        <td >
                            <el-button style="margin-left: 10px" size="small" type="primary" plain @click="flushPage" >刷新
                            </el-button>
                        </td>
                    </tr>
                </table>
            </div>

            <el-main style="position: relative">
                <el-table
                        :data="tableData"
                        style="width: 100%;height:50vh;"
                        border
                        ref="table"
                        :cell-class-name="tableRowClassName"
                        @cell-click="handleCellClick"
                        highlight-current-row
                >
                     <el-table-column prop="recStatus" fixed="left" min-width="120" max-width="200" label="状态">
                        <template v-slot="scope">
                            <span v-if="scope.row.recStatus == -1">检测中</span>
                            <span v-if="scope.row.recStatus == 0">初检</span>
                            <span v-if="scope.row.recStatus == 1">重新编辑</span>
                            <span v-if="scope.row.recStatus == 2">已审核</span>
                            <span v-if="scope.row.recStatus == 3">已批准</span>
                            <span v-if="scope.row.recStatus == 4">已上传</span>
                            <span v-if="scope.row.recStatus == 5">编制</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="liftNum" min-width="120" max-width="200"   label="产品编号">
                    </el-table-column>
                    <el-table-column prop="unit" min-width="220" max-width="300"   label="使用单位">
                    </el-table-column>
                    <el-table-column prop="loginNum" min-width="120" max-width="200"  label="登记证编号">
                    </el-table-column>
                    <el-table-column prop="areaName" min-width="120" max-width="200"   label="区域名称"></el-table-column>
                    <el-table-column prop="userAlias" min-width="120" max-width="200"   label="检测人员"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="recDate" min-width="120" max-width="200"  sortable label="检测时间">
                        <template v-slot="scope">
                            <span>{{ this.formatDate(scope.row.recDate, "yyyy-MM-dd") }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="plaitDate" min-width="120" max-width="200"  sortable label="提交审核时间" v-if="this.RecordFlag == 5">
                        <template v-slot="scope">
                            <span>{{ this.formatDate(scope.row.plaitDate, "yyyy-MM-dd") }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="processDate" min-width="120" max-width="200"   sortable label="审核时间" v-if="this.RecordFlag == 2">
                        <template v-slot="scope">
                            <span>{{ this.formatDate(scope.row.processDate, "yyyy-MM-dd") }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="ratifyData" min-width="120" max-width="200"   sortable label="批准时间" v-if="this.RecordFlag == 4 || this.RecordFlag == 3">
                        <template v-slot="scope">
                            <span>{{ this.formatDate(scope.row.ratifyData, "yyyy-MM-dd") }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="uploadDate" min-width="120" max-width="200"   sortable label="上传时间" v-if="this.RecordFlag == 4 || this.RecordFlag == 3">
                        <template v-slot="scope">
                            <span>{{ this.formatDate(scope.row.uploadDate, "yyyy-MM-dd") }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="rejectDetail" min-width="120" max-width="200"   label="退回原因"></el-table-column>
                    <el-table-column   prop="videoUrl" min-width="120" max-width="200"   label="检测视频是否存在">
                        <template v-slot="scope">
                            <span>{{  scope.row.videoUrl!=null && scope.row.videoUrl!=""?'存在':'不存在'  }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column   prop="superviseCode" min-width="120" max-width="200" fixed="right"   label="监察识别码">
                    </el-table-column>
                </el-table>
            </el-main>
            <el-footer>
                <div class="demonstration" style="margin: 10px 0">
                    <el-pagination v-model:currentPage="currentPage"
                                   v-model:page-size="pageSize"
                                   :page-sizes="[20, 40,60]"
                                   :small="small"
                                   :background="background"
                                   layout="total, sizes, prev, pager, next, jumper"
                                   :total="total"
                                   :prev="prev"
                                   :pager="pager"
                                   :next="next"
                                   :jumper="jumper"
                                   @size-change="handleSizeChange"
                                   @current-change="handleCurrentChange"></el-pagination>
                </div>
                <!--                :disabled="disabled"-->
            </el-footer>
        </el-container>

    </div>

    <el-dialog v-model="cxtj" title="查询条件" :lock-scroll="false"  width="80%" draggable :close-on-click-modal="false" :close-on-press-escape="false">
        <el-form :model="formchecked" label-position="left" ref="formRef"
                 size="medium" style="width: auto; height:auto; margin: 0 auto; position: relative">
            <table style="position: relative; width: auto; height: auto">
                <tr>
                    <td><!--检测时间大于等于-->
                        <el-form-item style="float: left" label="" prop="checked1" size="mini">
                            <el-checkbox label="检测时间大于等于" :disabled="!checkedA"
                                         v-model="formchecked.checked1"></el-checkbox>
                            <el-date-picker
                                    v-model="ThisForm.f1_startTimeOutweigh"
                                    value-format="YYYY-MM-DD HH:mm:ss"
                                    format="YYYY/MM/DD HH:mm:ss"
                                    type="datetime"
                                    :disabled="!formchecked.checked1"
                                    placeholder="选择日期时间"
                                    style="width: 200px;">
                            </el-date-picker>

                        </el-form-item>
                    </td>
                    <td> <!--工单ID-->
                        <el-form-item style="float: left" label="" prop="checked8" size="mini" class="formItem">

                            <el-checkbox label="工单ID" :disabled="!checkedB"
                                         v-model="formchecked.checked8"></el-checkbox>
                            <el-input v-model="ThisForm.orderId" :disabled="!formchecked.checked8"
                                      onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')" style="width: 150px"></el-input>

                        </el-form-item>
                    </td>


                    <td><!--检测人员-->
                        <el-form-item style="float: left" label="" prop="checked7" size="mini" class="formItem">
                            <el-checkbox label="检测人员" :disabled="!checkedB"
                                         v-model="formchecked.checked7"></el-checkbox>
                            <el-input v-model="ThisForm.userAlias" :disabled="!formchecked.checked7"
                                      style="width: 150px"></el-input>
                        </el-form-item>
                    </td>

                    <td>  <!--物业-->
                        <el-form-item style="float: left" label="" prop="checked6" size="mini" class="formItem">
                            <el-checkbox label="使用单位" :disabled="!checkedB"
                                         v-model="formchecked.checked3"></el-checkbox>
                            <el-input v-model="ThisForm.unit" :disabled="!formchecked.checked3"
                                      style="width: 150px;"></el-input>

                        </el-form-item>
                    </td>


                </tr>
                <tr>
                    <td> <!--检测时间小于等于-->
                        <el-form-item style="float: left" label="" prop="checked2" size="mini" class="formItem">

                            <el-checkbox label="检测时间小于等于" :disabled="!checkedA"
                                         v-model="formchecked.checked2"></el-checkbox>
                            <el-date-picker
                                    v-model="ThisForm.f2_startTimeLessthen"
                                    :disabled="!formchecked.checked2"
                                    type="datetime"
                                    value-format="YYYY-MM-DD HH:mm:ss"
                                    format="YYYY/MM/DD HH:mm:ss"
                                    placeholder="选择日期时间"
                                    style="width: 200px">
                            </el-date-picker>

                        </el-form-item>
                    </td>
                    <td> <!--电梯ID-->
                        <el-form-item style="float: left" label="" prop="checked9" size="mini" class="formItem">
                            <el-checkbox label="电梯ID" :disabled="!checkedB"
                                         v-model="formchecked.checked9"></el-checkbox>
                            <el-input v-model.number="ThisForm.liftId" :disabled="!formchecked.checked9"
                                      onkeyup="value=value.replace(/^(0+)|[^\dT#]+/g,'')" style="width: 150px"></el-input>

                        </el-form-item>
                    </td>

                    <td>  <!--物业-->
                        <el-form-item style="float: left" label="" prop="checked6" size="mini" class="formItem">
                            <el-checkbox label="物业" :disabled="!checkedB"
                                         v-model="formchecked.checked6"></el-checkbox>
                            <el-input v-model="ThisForm.areaName" :disabled="!formchecked.checked6"
                                      style="width: 150px; margin-left: 27px"></el-input>

                        </el-form-item>
                    </td>

                    <td>  <!--物业-->
                        <el-form-item style="float: left" label="" prop="checked6" size="mini" class="formItem">
                            <el-checkbox label="产品编号" :disabled="!checkedB"
                                         v-model="formchecked.checked4"></el-checkbox>
                            <el-input v-model="ThisForm.liftNum" :disabled="!formchecked.checked4"
                                      style="width: 150px;"></el-input>

                        </el-form-item>
                    </td>
                </tr>

                <tr>
                    <td>  <!--物业-->
                        <el-form-item style="float: left" label="" prop="checked6" size="mini" class="formItem">
                            <el-checkbox label="使用登记证编号" :disabled="!checkedB"
                                         v-model="formchecked.checked5"></el-checkbox>
                            <el-input v-model="ThisForm.loginNum" :disabled="!formchecked.checked5"
                                      style="width: 190px; margin-left: 15px; "></el-input>

                        </el-form-item>
                    </td>

                    <td>  <!--物业-->
                        <el-form-item style="float: left" label="" prop="checked6" size="mini" class="formItem">
                            <el-checkbox label="注册代码" :disabled="!checkedB"
                                         v-model="formchecked.checked10"></el-checkbox>
                            <el-input v-model="ThisForm.lifeRegistCode" :disabled="!formchecked.checked10"
                                      style="width: 135px; "></el-input>

                        </el-form-item>
                    </td>

                    <td>  <!--物业-->
                        <el-form-item style="float: left" label="" prop="checked6" size="mini" class="formItem">
                            <el-checkbox label="使用单位代码" :disabled="!checkedB"
                                         v-model="formchecked.checked11"></el-checkbox>
                            <el-input v-model="ThisForm.unitCode" :disabled="!formchecked.checked11"
                                      style="width: 100px;  "></el-input>

                        </el-form-item>
                    </td>

                    <td>  <!--物业-->
                        <el-form-item style="float: left" label="" prop="checked6" size="mini" class="formItem">
                            <el-checkbox label="监察识别码" :disabled="!checkedB"
                                         v-model="formchecked.checked12"></el-checkbox>
                            <el-input v-model="ThisForm.superviseCode" :disabled="!formchecked.checked12"
                                      style="width: 150px;"></el-input>

                        </el-form-item>
                    </td>


                    <el-form-item style="float: left" size="medium">
                        <div style="margin: 0 auto;">
                        </div>
                    </el-form-item>
                </tr>
                <tr>
                    <td>  <!--物业-->
                        <el-form-item  style="float: left" label="" prop="checked6" size="mini" class="formItem">
                            <el-checkbox label="状态" :disabled="!checkedB"
                                         v-model="formchecked.checked13"></el-checkbox>
                            <!--              <el-input v-model="ThisForm.recStatus" :disabled="!formchecked.checked13"-->
                            <!--                        style="width: 150px;"></el-input>-->
                            <el-select v-model="ThisForm.recStatus"  clearable  :disabled="!formchecked.checked13">
                                <el-option label="检测中" value="-1"></el-option>
                                <el-option label="初检" value="0"></el-option>
                                <el-option label="编制" value="5"></el-option>
                                <el-option label="审核" value="2"></el-option>
                                <el-option label="批准" value="3"></el-option>
                                <el-option label="上传" value="4"></el-option>
                            </el-select>
                        </el-form-item>
                    </td>
                </tr>

            </table>
        </el-form>
        <template #footer>
                      <span class="dialog-footer">
                        <el-button style="margin-top: -50px" @click="cxtj = false">关闭</el-button>
                        <el-button style="margin-top: -50px" type="primary" @click="submitForm('formchecked','ThisForm')" :disabled="disabled">确定</el-button>
                      </span>
        </template>
    </el-dialog>
</template>

<script>
    import request from "@/util/request";
    import moment from "moment";
    export default {
        name: "DeviceStatus",
        data() {
            return {
                ip:localStorage.getItem("ip"),
                urls: [],
                items:[
                    {
                        content:'',
                        person:'',
                        time:'',
                        // color:'blue',
                        beizhu: ''
                    }
                ],
                items2: [
                    {
                        content:'',
                        person:'',
                        time:'',
                        // color:'blue',
                        beizhu: ''
                    },
                    {
                        content:'',
                        person:'',
                        time:'',
                        // color:'green',
                        beizhu: ''
                    },
                ],
                items3: [
                    {
                        content:'',
                        person:'',
                        time:'',
                        // color:'blue',
                        beizhu: ''
                    },
                    {
                        content:'',
                        person:'',
                        time:'',
                        // color:'green',
                        beizhu: ''
                    },
                    {
                        content:'',
                        person:'',
                        time:'',
                        // color:'green',
                        beizhu: ''
                    },
                ],
                // select:null,
                form: {},
                options: [],//评分方案的类型列表
                option: {},//评分方案的类型对象
                formResult: {
                    recStatus:0,
                }, //驳回表单
                dialogFormVisible: false,
                dialogResultVisible: false, //不合格dialog控制
                tp: false, //检测图片dialog控制
                timeline: false,
                timeline2: false,
                timeline3: false,
                currentPage: 1,
                pageSize: 20,
                total: 10,
                small: "small",
                background: "background",
                prev: this.currentPage - 1,
                pager: this.currentPage,
                next: this.currentPage + 1,
                jumper: this.currentPage,
                ticket: [], //未分页的数据
                tableData: [],//渲染到页面上的数据

                disabledAudit: false,
                disabledQualified: false,
                theOne: {}, //查看的单条数据
                RecordFlag: this.$route.query.RecordFlag,
                cxtj:false,
                //表单收集的数据
                ThisForm: {
                    f1_startTimeOutweigh: this.formatDate(this.getbeforetime(), "yyyy-MM-dd hh:mm:ss"),
                    f2_startTimeLessthen: this.formatDate(this.getaftertime(), "yyyy-MM-dd hh:mm:ss"),
                    // new_shsj: this.formatDate(this.shtime(), "yyyy-MM-dd"),
                    // new_pzsj: this.formatDate(this.shtime(), "yyyy-MM-dd"),
                },
                //多选框
                formchecked: {
                    checked1: true,
                    checked2: true,
                    checked3: false,
                    checked4: false,
                    checked5: false,
                    checked6: false,
                    checked7: false,
                    checked8: false,
                    checked9: false,
                    checked10: false,
                    checked11: false,
                    checked12: false,
                    checked13: false,
                },
                sh_form: {},
                pz_form: {},
                checkedA: true,
                checkedB: true,
                ticketPush: {},

                //图片路径
                imgUrl: require('/src/assets/logo.png'),


                authList:[],//用户的权限
                fileList: [{
                }],

            }
        },
        created() {

            this.load();
            // this.getList();
        },
        methods: {
            //刷新页面
            flushPage(){
                // this.load();
                this.$nextTick(() => {
                    // this.$refs.table.doLayout()
                    console.log("刷新成功")
                    location.reload();
                    // this.$router.push({path:'record', query:{RecordFlag : 5}})
                })
            },
            // 获取时间
            getbeforetime() {
                //获取到的时间 (中国标准时间)
                var d = new Date((new Date().getTime() - 24 * 60 * 60 * 1000));
                // 处理成的格式
                var time = d.getFullYear()-1 + '-' + (d.getMonth() + 1) + '-' + (d.getDate())
                    + ' 00:00:01';
                return new Date(time);
            },
            getaftertime() {
                var d = new Date();
                var time = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate()
                    + ' 23:59:59';
                return new Date(time);
            },
            //页面初始化
            load() {
                let  name = sessionStorage.getItem("userName");
                if(name==null||name ==""||name ==undefined){
                    this.$message({
                        type: 'warning',
                        message: '登录超时请重新登录!'
                    });
                    this.$router.push({path: '/login', query: {}});
                    return;
                }
                    request.post('/RecDetView/queryDeviceStatus' ).then(res => {
                        console.log(res);
                        console.log(this.ticket)
                        this.ticket = res;
                        this.total = this.ticket.length
                        this.loadang = false
                        this.getPageInfo()
                    })

            },
            // 表格查询
            //提交数据到后台
            submitForm(formchecked, ThisForm) {
                console.log(formchecked, ThisForm);
                console.log(this.ThisForm);
                console.log(this.mergeSQL());
                    if (!this.formchecked.checked1 && !this.formchecked.checked2 && !this.formchecked.checked6 && !this.formchecked.checked7 && !this.formchecked.checked8 && !this.formchecked.checked9 && !this.formchecked.checked3 && !this.formchecked.checked4 && !this.formchecked.checked5 && !this.formchecked.checked10 && !this.formchecked.checked11 && !this.formchecked.checked12 && !this.formchecked.checked13) {
                        this.tableData = [];
                        this.total = 0
                        // this.loadang = false
                        this.cxtj = false
                        console.log("没勾选值")
                        this.$message({
                            type: 'error',
                            message: '请勾选要查询的内容!'
                        });
                    }
                    else if (this.formchecked.checked1 || this.formchecked.checked2 || this.formchecked.checked6  || this.formchecked.checked7  || this.formchecked.checked8  || this.formchecked.checked9 || this.formchecked.checked3 || this.formchecked.checked4 || this.formchecked.checked5 || this.formchecked.checked10 || this.formchecked.checked11 || this.formchecked.checked12|| this.formchecked.checked13 ) {
                        request.post("/RecDetView/combSelect4",
                            {"sql": this.mergeSQL(), "RecordFlag": this.RecordFlag, userName: sessionStorage.getItem("userName")
                                ,roleId:sessionStorage.getItem("roleId"),
                                areaId:sessionStorage.getItem("areaId")}).then(res => {
                            console.log(res)
                            this.ticket = [];
                            this.cxtj = false
                            console.log(this.ticket)
                            this.ticket = res;
                            this.total = this.ticket.length
                            this.cxtj = false
                            this.getPageInfo()
                        })
                        if ((this.formchecked.checked1 && this.ThisForm.f1_startTimeOutweigh == '') || (this.formchecked.checked8 && this.ThisForm.orderId == undefined || this.ThisForm.orderId == '') || (this.formchecked.checked6 && this.ThisForm.areaName == undefined) || (this.formchecked.checked6 && this.ThisForm.areaName == '') || (this.formchecked.checked7 && this.ThisForm.userAlias == undefined) ||
                            (this.formchecked.checked7 && this.ThisForm.userAlias == '') || (this.formchecked.checked9 && this.ThisForm.liftId == undefined) || (this.formchecked.checked9 && this.ThisForm.liftId == '') || (this.formchecked.checked3 && this.ThisForm.unit == undefined)
                            || (this.formchecked.checked3 && this.ThisForm.unit == '') || (this.formchecked.checked4 && this.ThisForm.liftNum == undefined) || (this.formchecked.checked4 && this.ThisForm.liftNum == '') || (this.formchecked.checked5 && this.ThisForm.loginNum == undefined) || (this.formchecked.checked5 && this.ThisForm.loginNum == '') || (this.formchecked.checked10 && this.ThisForm.lifeRegistCode == undefined) || (this.formchecked.checked10 && this.ThisForm.lifeRegistCode == '') || (this.formchecked.checked11 && this.ThisForm.unitCode == undefined)
                            || (this.formchecked.checked11 && this.ThisForm.unitCode == '') ||
                            (this.formchecked.checked12 && this.ThisForm.superviseCode == undefined) || (this.formchecked.checked12 && this.ThisForm.superviseCode == '') || (this.formchecked.checked13 && (this.ThisForm.recStatus == ''||this.ThisForm.recStatus == undefined))) {
                            this.tableData = [];
                            this.cxtj = false
                            this.$message({
                                type: 'error',
                                message: '请输入要查询的内容!'
                            });
                        }
                    }
            },
            showQuery() {
                this.cxtj = true
            },
            //拼接sql
            mergeSQL() {
                var SQL = '';
                var SQL1 = " and recDate >= ",
                    SQL2 = " and recDate <= ",
                    SQL3 = " and unit like ",
                    SQL4 = " and liftNum like ",
                    SQL5 = " and loginNum like ",
                    SQL6 = " and areaName like ",
                    SQL7 = " and userAlias like ",
                    SQL8 = " and orderId = ",
                    SQL9 = " and liftId = ",
                    SQL10 = " and lifeRegistCode like ",
                    SQL11 = " and unitCode like ",
                    SQL12 = " and superviseCode like ",
                    SQL13 = " and recStatus = ";
                if (this.formchecked.checked1 && this.ThisForm.f1_startTimeOutweigh !== '' && this.ThisForm.f1_startTimeOutweigh !== undefined) {

                    // eslint-disable-next-line no-useless-escape
                    SQL1 += "'" + moment(this.ThisForm.f1_startTimeOutweigh).format('YYYY-MM-DD HH:mm:ss') + "'";
                } else {
                    SQL1 = '';
                }
                if (this.formchecked.checked2 && this.ThisForm.f2_startTimeLessthen !== '') {
                    // eslint-disable-next-line no-useless-escape
                    SQL2 += "'" + moment(this.ThisForm.f2_startTimeLessthen).format('YYYY-MM-DD HH:mm:ss') + "'";
                    //console.log(SQL2)
                } else {
                    SQL2 = '';
                }
                if (this.formchecked.checked3 && this.ThisForm.unit !== '') {
                    // eslint-disable-next-line no-useless-escape
                    SQL3 += "'" + "%" +this.ThisForm.unit + "%" +"'";
                    //console.log(SQL2)
                } else if (this.formchecked.checked3 && this.ThisForm.unit == '') {
                    SQL3 += "'" + "%" + undefined + "%" + "'";
                } else {
                    SQL3 = '';
                }
                if (this.formchecked.checked4 && this.ThisForm.liftNum !== '') {
                    // eslint-disable-next-line no-useless-escape
                    SQL4 += "'" + "%" +this.ThisForm.liftNum + "%" +"'";
                    //console.log(SQL2)
                } else if (this.formchecked.checked4 && this.ThisForm.liftNum == '') {
                    SQL4 += "'" + "%" + undefined + "%" + "'";
                } else {
                    SQL4 = '';
                }
                if (this.formchecked.checked5 && this.ThisForm.loginNum !== '') {
                    // eslint-disable-next-line no-useless-escape
                    SQL5 += "'" + "%" +this.ThisForm.loginNum + "%" +"'";
                    //console.log(SQL2)
                } else if (this.formchecked.checked5 && this.ThisForm.loginNum == '') {
                    SQL5 += "'" + "%" + undefined + "%" + "'";
                } else {
                    SQL5 = '';
                }
                if (this.formchecked.checked6 && this.ThisForm.areaName !== '') {
                    SQL6 += "'" + "%" +this.ThisForm.areaName + "%" +"'";
                }  else if (this.formchecked.checked6 && this.ThisForm.areaName == '') {
                    SQL6 += "'" + "%" + undefined + "%" + "'";
                } else {
                    SQL6 = '';
                }
                if (this.formchecked.checked7 && this.ThisForm.userAlias !== '') {
                    SQL7 += "'" + "%" + this.ThisForm.userAlias + "%" + "'";
                } else if (this.formchecked.checked7 && this.ThisForm.userAlias == '') {
                    SQL7 += "'" + "%" + undefined + "%" + "'";
                } else {
                    SQL7 = '';
                }
                if (this.formchecked.checked8 && this.ThisForm.orderId !== '') {
                    SQL8 += this.ThisForm.orderId;
                } else {
                    SQL8 = '';
                }
                if (this.formchecked.checked9 && this.ThisForm.liftId !== '') {
                    SQL9 += this.ThisForm.liftId;
                } else {
                    SQL9 = '';
                }
                if (this.formchecked.checked10 && this.ThisForm.lifeRegistCode !== '') {
                    // eslint-disable-next-line no-useless-escape
                    SQL10 += "'" + "%" +this.ThisForm.lifeRegistCode + "%" +"'";
                    //console.log(SQL2)
                } else if (this.formchecked.checked10 && this.ThisForm.lifeRegistCode == '') {
                    SQL10 += "'" + "%" + undefined + "%" + "'";
                } else {
                    SQL10 = '';
                }
                if (this.formchecked.checked11 && this.ThisForm.unitCode !== '') {
                    // eslint-disable-next-line no-useless-escape
                    SQL11 += "'" + "%" +this.ThisForm.unitCode + "%" +"'";
                    //console.log(SQL2)
                } else if (this.formchecked.checked11 && this.ThisForm.unitCode == '') {
                    SQL11 += "'" + "%" + undefined + "%" + "'";
                } else {
                    SQL11 = '';
                }
                if (this.formchecked.checked12 && this.ThisForm.superviseCode !== '') {
                    // eslint-disable-next-line no-useless-escape
                    SQL12 += "'" + "%" +this.ThisForm.superviseCode + "%" +"'";
                    //console.log(SQL2)
                } else if (this.formchecked.checked12 && this.ThisForm.superviseCode == '') {
                    SQL12 += "'" + "%" + undefined + "%" + "'";
                } else {
                    SQL12 = '';
                }
                if (this.formchecked.checked13 && this.ThisForm.recStatus !== '') {
                    SQL13 += this.ThisForm.recStatus;
                } else {
                    SQL13 = '';
                }
                SQL += SQL1 + SQL2 + SQL3 + SQL4 + SQL5 + SQL6 + SQL7 + SQL8 + SQL9 + SQL10 + SQL11 + SQL12+ SQL13;
                return SQL + '      order by updateDate desc';
            },
            //时间格式
            formatDate(value, fmt) {
                if (value == null || value == '') {
                    return ""
                }
                let getDate = new Date(value);
                let o = {
                    'M+': getDate.getMonth() + 1,
                    'd+': getDate.getDate(),
                    'h+': getDate.getHours(),
                    'm+': getDate.getMinutes(),
                    's+': getDate.getSeconds(),
                    'q+': Math.floor((getDate.getMonth() + 3) / 3),
                    'S': getDate.getMilliseconds()
                };
                if (/(y+)/.test(fmt)) {
                    fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length))
                }
                for (let k in o) {
                    if (new RegExp('(' + k + ')').test(fmt)) {
                        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
                    }
                }
                return fmt;
            },

            //分页三件套
            // 获取当前页的数据信息
            getPageInfo() {
                //清空pageTicket中的数据
                this.tableData = [];
                // 获取当前页的数据
                for (let i = (this.currentPage - 1) * this.pageSize; i < this.total; i++) {
                    //把遍历的数据添加到pageTicket里面
                    this.tableData.push(this.ticket[i]);
                    //判断是否达到一页的要求
                    if (this.tableData.length === this.pageSize) break;
                }

            },
            handleSizeChange(pageSize) {
                //修改当前每页的数据行数
                this.pageSize = pageSize;
                //数据重新分页
                this.getPageInfo();
            },
            handleCurrentChange(pageNum) {
                //修改当前的页码
                this.currentPage = pageNum;
                //数据重新分页
                this.getPageInfo()
            },
            tableRowClassName({rowIndex}) {
                // console.log(row)
                // console.log(rowIndex)
                if (rowIndex === 1) {
                    // console.log(row)
                    // console.log(rowIndex)
                    return 'warning-row';
                } else if (rowIndex === 3) {
                    // console.log(row)
                    // console.log(rowIndex)
                    return 'success-row';
                }
                return '';
            },

        }
    }
</script>

<style scoped>

</style>